import React from "react";
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";
import { imageCodes } from "../../template_codes/willow/home_page_codes";

export default function MediaRoom() {

    return (
        <div>EGMedia Room</div>
    );

}